import { get } from '../httpClient';

export const analyticsAPI = {
  getPageViews: params => get('/api/analytics/pageviews', params),
};
